import { ImpactUpsellContent } from '.';

export const detailsText: ImpactUpsellContent = {
  header: {
    upgradePrompt: 'Upgrade Required',
    titlePrefix: 'Unlock deeper insight with the ',
    title: 'SDG Impact Dashboard',
    content:
      'Upgrade your membership to access granular analytics and benchmarking tools, including:',
  },

  contentSections: [
    {
      sectionReference: 'features',
      icon: 'padlock',
      bullets: [
        { title: 'Access to historical data from 2020 onwards' },
        { title: 'Full SDG and indicator-level analysis' },
        { title: 'Benchmark your performance against peers' },
        { title: 'Trend tracking and performance insights' },
        { title: 'Data to support reporting and strategic decision making' },
      ],
    },
  ],

  buttons: {
    cta: {
      text: 'Learn More',
      url:
        'https://www.timeshighereducation.com/our-solutions/data-and-insights/sustainability-impact-network-membership?utm_source=datapoints&utm_medium=banner&utm_campaign=details_banner',
    },
    dismiss: 'Go Back',
  },
};
